import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ILookup, selectLookupResponse } from '../../../features/login/loginSlice';

type Props = {
  children: React.ReactNode;
};
export const LoginRedirectToHAT: React.FC<Props> = (props) => {
  const lookupResponse = useSelector(selectLookupResponse);

  const processLogin = (loginDetails?: ILookup) => {
    if (!loginDetails) return;

    const { hatName, hatCluster } = loginDetails;

    if (hatName && hatCluster) {
      setTimeout(function() {
        //navigate the user after a second
        window.location.href = `https://${hatName}.${hatCluster}/#/user/login`;
      }, 1000);
    }
  };

  useEffect(() => {
    processLogin(lookupResponse);
  }, [lookupResponse]);
  return <>{props.children}</>;
};
